<template>
  <div class="v-login-loginbox">
    <div class="login-inner">
      <div class="v-login-loginbox__head">
        <login-head :isRegisterTab="false" v-on="$listeners" />
      </div>
      <div class="login-main" v-if="loginType === ACCOUNT_TYPE">
        <account
          :options="options"
          :isResize="true"
          v-on="$listeners"
          @changeLoginType="changeLoginType"
        />
      </div>
      <div class="login-main" v-if="loginType === PHONE_TYPE">
        <mobile
          :options="options"
          :isResize="true"
          v-on="$listeners"
          @changeLoginType="changeLoginType"
        />
      </div>
    </div>
    <div class="login-others-wrap">
      <login-others :env="useOptions.env" :otherLoginCallback="useOptions.otherLoginCallback" />
    </div>
  </div>
</template>

<script>
import { ACCOUNT_TYPE, PHONE_TYPE } from './libs/constants';
import defaults from './libs/defaults';
import LoginHead from './components/LoginHead.vue';
import LoginOthers from './components/LoginOthers.vue';
import Account from './Account.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'v-login-loginbox',
  props: {
    options: { type: Object, default: () => ({}) },
  },
  components: {
    LoginHead,
    LoginOthers,
    Account,
    Mobile,
  },
  data() {
    return {
      ACCOUNT_TYPE,
      PHONE_TYPE,
      loginType: ACCOUNT_TYPE,
    };
  },
  computed: {
    useOptions() {
      return Object.assign({}, defaults, this.options);
    },
  },
  methods: {
    // 切换登录方式
    changeLoginType(type) {
      this.loginType = type;
    },
    // 去注册
    toRegister() {
      this.$emit('changeRegister');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './libs/mixin.scss';

.v-login-loginbox {
  position: relative;
  height: 100%;
  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .login-inner {
    padding: 40px 70px 0;
  }
  .login-others-wrap {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
  }
}
.v-login-loginbox__head {
  padding-bottom: 30px;
}
</style>
